import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const MoneyElement = styled(Stack)`
  /* Override spacing between input and money element */
  margin-right: calc(-1 * ${cssVar('spacing-lg')});
`;
